import { Controller } from "stimulus";

export default class extends Controller {
  submit(event) {
    event.preventDefault();
    // Crear la query string con los parámetros del formulario
    const formData = new FormData(this.element);
    const params = new URLSearchParams(formData).toString();
    const url = `${this.element.action}?${params}`;
    
    // Abrir la URL en una nueva pestaña
    window.open(url, "_blank");
    
    // Reiniciar el formulario y limpiar la URL actual
    this.element.reset();
    history.replaceState(null, '', this.element.action);
    
    // Refrescar la página después de un breve retraso
    setTimeout(() => {
      location.reload();
    }, 100);
  }
}
